import {Component, effect, inject, signal} from '@angular/core';
import {NgClass} from "@angular/common";

import {AssetComponent} from "src/app/presentation/common/asset.component";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {
  PrecipitationPointButtonComponent
} from "src/app/presentation/main-view/information-center/precipitation-sample-points/precipitation-point-button/precipitation-point-button.component";
import {
  PrecipitationSvgComponent
} from "src/app/presentation/common/icons/precipitation-svg/precipitation-svg.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {FixedSamplePoint} from "src/app/infrastructure/moovement-api/models/asset";
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';

@Component({
  selector: 'app-precipitation-points',
  imports: [
    PrecipitationPointButtonComponent,
    PrecipitationSvgComponent,
    NgClass
  ],
  templateUrl: './precipitation-points.component.html',
  styleUrl: './precipitation-points.component.css'
})
export class PrecipitationPointsComponent extends AssetComponent {

  filteredPrecipitationSamplePoints = signal<FixedSamplePoint[]>([]);
  allPrecipitationSamplePoints = signal<FixedSamplePoint[]>([]);

  private fixedSamplePointsStore = inject(FixedSamplePointsStore);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);

    effect(() => {
      if (this.fixedSamplePointsStore.loading()) return;

      const precipitationSamplePoints = this.fixedSamplePointsStore.precipitationSamplePoints();
      this.allPrecipitationSamplePoints.set(precipitationSamplePoints);
      this.filteredPrecipitationSamplePoints.set(precipitationSamplePoints);
    });
  }

  filterResults(input: any) {
    if (!input.value) {
      this.filteredPrecipitationSamplePoints.set(this.allPrecipitationSamplePoints());
      return;
    }

    const value = (input.value as string).toLowerCase()
    this.filteredPrecipitationSamplePoints.set(this.allPrecipitationSamplePoints().filter(precipitationSamplePoint => {
        return precipitationSamplePoint?.id?.toLowerCase().includes(value)
          || precipitationSamplePoint?.name?.toLowerCase().includes(value)
      }
    ));
  }
}
